import React from "react";
import styles from "./Searchbar.module.scss";
import { IconSearch } from "@tabler/icons-react";
import { CloseButton } from "@mantine/core";

const Searchbar = ({ placeholder, searchValue, setSearchValue }) => {
  return (
    <div className={styles.search_bar}>
      <IconSearch />
      <input
        type="text"
        placeholder={placeholder}
        value={searchValue}
        onChange={(e) => {
          setSearchValue(e.target.value);
        }}
      />
      {searchValue && (
        <CloseButton
          onClick={() => {
            setSearchValue("");
          }}
        />
      )}
    </div>
  );
};

export default Searchbar;
